// extracted by mini-css-extract-plugin
module.exports = {"headerInfo":"styles_headerInfo__3IW60"};